import request from './request/uxcb';

function buildFormData(params) {
  const formData = new FormData();

  Object.keys(params).map(key => formData.append(key, params[key]));
  return formData;
}

export function getAuthConfig(businessNo, mobile) {
  const params = { bizType: 'authConfig', businessNo, mobile };
  return request
    .get('/uxcb/interFaces/common/onlineProposal.do', { params })
    .then(res => res.data);
}

export function getProposal(businessNo, mobile) {
  const params = { bizType: 'getPTMsg', businessNo, mobile };
  return request
    .get('/uxcb/interFaces/external/eleProposal.do', { params })
    .then(res => res.data);
}

export function signProposal(businessNo, mobile, dataURL, file) {
  const formData = new FormData();
  formData.append('bizType', 'uploadIMG');
  formData.append('dataURL', dataURL);
  formData.append('file', file, file.name);
  formData.append('businessNo', businessNo);
  formData.append('mobile', mobile);

  return request
    .post('/uxcb/interFaces/external/eleProposal.do', formData)
    .then(res => res.data);
}

export function getPaymentType(bizNo) {
  const data = {
    head: { transCode: 'BaseCodeZy', transType: 'Req', token: '' },
    queryType: 'elPayType',
    conditions: [],
    loginCom: '',
    userCode: '',
    bizNo,
  };

  return request
    .post('/uxcb/interFaces/common/special/BaseCodeZy.do', data)
    .then(res => res.data);
}

export function applyOrder(businessNo, mobile, payType, stagingTimes) {
  const params = {
    bizType: 'orderApply',
    businessNo,
    mobile,
    payType,
    stagingTimes,
  };
  return request
    .get('/uxcb/interFaces/external/eleProposal.do', { params })
    .then(res => res.data);
}

export function getOrderInfo(businessNo, mobile, payType, poaCode) {
  const params = { bizType: 'orderMsg', businessNo, mobile, payType, poaCode };
  return request
    .get('/uxcb/interFaces/external/eleProposal.do', { params })
    .then(res => res.data);
}

export function getProposalLink(params, mobile) {
  const { bizType, businessNo, clauseModelNo: modelNo, comCode } = params;
  const query = { bizType, businessNo, modelNo, comCode, mobile };
  const search = Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join('&');

  return `/uxcb/interFaces/external/printProposal.do?${search}`;
}

export function sendAuthSms(businessNo, mobile) {
  const params = { bizType: 'sendPhoneMessage', businessNo, mobile };
  return request
    .get('/uxcb/interFaces/common/onlineProposal.do', { params })
    .then(res => res.data);
}

export function checkAuthSms(
  businessNo,
  mobile,
  smsAuthenticationNo,
  verificationCode,
) {
  const params = {
    bizType: 'checkMessageCode',
    businessNo,
    mobile,
    smsAuthenticationNo,
    verificationCode,
  };
  return request
    .get('/uxcb/interFaces/common/onlineProposal.do', { params })
    .then(res => res.data);
}

export function checkIdCode(businessNo, mobile, idCode) {
  const params = { businessNo, mobile, idCode, bizType: 'checkIdCode' };

  return request
    .get('/uxcb/interFaces/common/onlineProposal.do', { params })
    .then(res => res.data);
}

export function getCertifyInit(businessNo, mobile, metaInfo, appSource) {
  const params = {
    businessNo,
    mobile,
    metaInfo,
    appSource,
    bizType: 'faceIdInit',
    sceneCode: 'FACE_SDK',
  };

  return request
    .get('/uxcb/interFaces/common/onlineProposal.do', { params })
    .then(res => res.data);
}

export function getCertifyResult(businessNo, certifyId) {
  const params = {
    businessNo,
    certifyId,
    bizType: 'getFaceIdCode',
  };

  return request
    .get('/uxcb/interFaces/common/onlineProposal.do', { params })
    .then(res => res.data);
}

// 电子签名初始化
export function getSignedInit(businessNo) {
  const params = { businessNo };

  return request
    .post('/uxcb/api/v1/e-signed/init', params)
    .then(res => res.data);
}

// 电子签名验证
export function discernSigned(businessNo, mobile, file, fileIndex) {
  const formData = new FormData();
  formData.append('fileIndex', fileIndex);
  formData.append('file', file, file.name);
  formData.append('businessNo', businessNo);
  formData.append('mobile', mobile);

  return request
    .post('/uxcb/api/v1/e-signed/discern', formData)
    .then(res => res.data);
}

// 确认提交电子签名
export function uploadSigned(businessNo) {
  const params = { businessNo };

  return request
    .post('/uxcb/api/v1/e-signed/upload', params)
    .then(res => res.data);
}

// 投保承诺书电子签名验证
export function discernSignedInsure(businessNo, mobile, file, fileIndex) {
  const formData = new FormData();
  formData.append('fileIndex', fileIndex);
  formData.append('file', file, file.name);
  formData.append('businessNo', businessNo);
  formData.append('mobile', mobile);
  formData.append('signType', 'nonBizTruck');

  return request
    .post('/uxcb/api/v1/e-signed/discern', formData)
    .then(res => res.data);
}

// 确认提交电子签名
export function uploadSignedInsure(businessNo) {
  const params = { businessNo, uploadType: 'nonBizTruck' };

  return request
    .post('/uxcb/api/v1/e-signed/upload', params)
    .then(res => res.data);
}
